import Movement from "../Movement";
import Events from "../Events";
import Insights from "../Insights";
import Telematics from "../Telematics";
import Specification from "../Specification";
import Maintenance from "../Maintenance";

import ContractDetails from "../ContractDetails";
import Contacts from "../Contacts";
import Items from "../Items";
import Labels from "../Labels";
import Notes from "../Notes";
import config from "../../../secrets/config";
import { mapGetters } from "vuex";

import Trips from "../Trips";
import ActiveAlerts from "../ActiveAlerts";

export default {
  name: "view-component",

  components: {
    Movement,
    Events,
    Insights,
    Telematics,
    Specification,
    ContractDetails,
    Contacts,
    Items,
    Labels,
    Notes,
    Maintenance,
    Trips,
    ActiveAlerts,
  },
  props: ["cName", "respData"],

  data() {
    return {
      tab: null,
      items: [],
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.componentLoad();
  },
  methods: {
    componentLoad() {
      if (this.cName == "view-customer-owned-equipment-details") {
        let enabletrips = config.ENABLE_TRIPS;
        if (enabletrips == true) {
          this.items = [
            //   { tab: 'Movement' , tabName:'Movement'

            // },
            { tab: "Events", tabName: "Events" },
            { tab: "Insights", tabName: "Insights" },
            { tab: "Telematics", tabName: "Telematics" },
            { tab: "Specification", tabName: "Specification" },
            { tab: "Maintenance", tabName: "Maintenance" },
            { tab: "Trips", tabName: "Trips" },
          ];
        } else {
          this.items = [
            //   { tab: 'Movement' , tabName:'Movement'

            // },
            { tab: "Events", tabName: "Events" },
            { tab: "Insights", tabName: "Insights" },
            { tab: "Telematics", tabName: "Telematics" },
            { tab: "Specification", tabName: "Specification" },
            { tab: "Maintenance", tabName: "Maintenance" },
            // { tab: "Trips", tabName: "Trips" },
          ];
        }
      } else if (this.cName == "view-birch-owned-equipment-details") {
        let enabletrips = config.ENABLE_TRIPS;
        if (
          enabletrips == true &&
          (this.roles == "Admin" || this.roles == "Birch User")
        ) {
          this.items = [
            //   { tab: 'Movement' , tabName:'Movement'

            // },
            { tab: "Events", tabName: "Events" },
            { tab: "Insights", tabName: "Insights" },
            { tab: "Telematics", tabName: "Telematics" },
            { tab: "Specification", tabName: "Specification" },
            // { tab: "Maintenance", tabName: "Maintenance" },
            { tab: "Trips", tabName: "Trips" },
            { tab: "ActiveAlerts", tabName: "Active Alerts" },
          ];
        } else if (enabletrips == true && this.roles == "Customer") {
          this.items = [
            //   { tab: 'Movement' , tabName:'Movement'

            // },
            // { tab: "Events", tabName: "Events" },
            // { tab: "Insights", tabName: "Insights" },
            // { tab: "Telematics", tabName: "Telematics" },
            // { tab: "Specification", tabName: "Specification" },
            // { tab: "Maintenance", tabName: "Maintenance" },
            { tab: "Trips", tabName: "Trips" },
          ];
        } else {
          this.items = [
            //   { tab: 'Movement' , tabName:'Movement'

            // },
            { tab: "Events", tabName: "Events" },
            { tab: "Insights", tabName: "Insights" },
            { tab: "Telematics", tabName: "Telematics" },
            { tab: "Specification", tabName: "Specification" },
            // { tab: "Maintenance", tabName: "Maintenance" },
            // { tab: "Trips", tabName: "Trips" },
          ];
        }
      } else if (this.cName == "view-contract-details") {
        this.items = [
          //   { tab: 'Movement'

          // },
          { tab: "ContractDetails", tabName: "Contract Details" },
          // { tab: 'Contacts' , tabName: 'Contacts'
          // },
          // { tab: 'Items' , tabName: 'Items'},
          // { tab: 'Notes' , tabName: 'Notes'}
        ];
      } else {
        let enabletrips = config.ENABLE_TRIPS;
        if (enabletrips == true) {
          this.items = [
            //   { tab: 'Movement' , tabName:'Movement'

            // },
            { tab: "Events", tabName: "Events" },
            { tab: "Insights", tabName: "Insights" },
            { tab: "Telematics", tabName: "Telematics" },
            { tab: "Specification", tabName: "Specification" },
            // { tab: "Maintenance", tabName: "Maintenance" },
            { tab: "Trips", tabName: "Trips" },
          ];
        } else {
          this.items = [
            //   { tab: 'Movement' , tabName:'Movement'

            // },
            { tab: "Events", tabName: "Events" },
            { tab: "Insights", tabName: "Insights" },
            { tab: "Telematics", tabName: "Telematics" },
            { tab: "Specification", tabName: "Specification" },
            // { tab: "Maintenance", tabName: "Maintenance" },
            // { tab: "Trips", tabName: "Trips" },
          ];
        }
      }
    },
  },
};
